/** Encode IMAP folder name for URL path segments. */
export function encodeFolderKey(imapName: string): string {
  const b64 = btoa(unescape(encodeURIComponent(imapName)));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decodeFolderKey(key: string): string {
  const pad = key.length % 4 === 0 ? '' : '='.repeat(4 - (key.length % 4));
  const b64 = key.replace(/-/g, '+').replace(/_/g, '/') + pad;
  return decodeURIComponent(escape(atob(b64)));
}

export function encodeThreadKey(threadId: string): string {
  return encodeFolderKey(threadId);
}

export function decodeThreadKey(key: string): string {
  return decodeFolderKey(key);
}

export function liveFolderPath(accountId: number, imapName: string): string {
  return `/folder/${accountId}/${encodeFolderKey(imapName)}`;
}

export function liveMessagePath(accountId: number, imapName: string, uid: number): string {
  return `/imap/message/${accountId}/${encodeFolderKey(imapName)}/${uid}`;
}

export function liveThreadPath(
  accountId: number,
  imapName: string,
  threadId: string,
  uids?: number[]
): string {
  const base = `/imap/thread/${accountId}/${encodeFolderKey(imapName)}/${encodeThreadKey(threadId)}`;
  if (uids?.length) return `${base}?uids=${uids.join(',')}`;
  return base;
}
